import { mapMutations, mapState } from "vuex";
import { components } from "../external-components/components";
import { loadFiles } from "../utils/file-loading";

const itemSort = (item1, item2) => {
    const name1 = (item1.label || item1.name).toLowerCase();
    const name2 = (item2.label || item2.name).toLowerCase();

    // eslint-disable-next-line no-nested-ternary
    return (name1 > name2) ? 1 : ((name2 > name1) ? -1 : 0);
};

export default {
    computed: {
        ...mapState("components", ["sidebarComponents"])
    },
    methods: {
        ...mapMutations("components", ["addBasicComponent", "setSidebarBasicLoading"]),

        __loadComponents() {
            const loadPromises = [];
            this.setSidebarBasicLoading(true);
            Object.entries(components).forEach(component => {
                const [name, settings] = component;

                loadPromises.push(
                    loadFiles(settings.files).then(() => {
                        this.addBasicComponent({ name, settings });
                    })
                );
            });

            return new Promise(resolve => {
                Promise.all(loadPromises).then(() => {
                    this.sidebarComponents.basic.layout.sort(itemSort);
                    this.sidebarComponents.basic.standard.sort(itemSort);
                    this.sidebarComponents.basic.form.sort(itemSort);

                    this.setSidebarBasicLoading(false);
                    resolve();
                });
            });
        }
    }
};

/*

    state.sidebarComponents.basic["form"].sort((a, b) => {
        let name1 = (a.label || a.name).toLowerCase(), name2 = (b.label || b.name).toLowerCase(), sortValue = 0;

        if (name1 > name2) {
            sortValue = 1;
        } else if (name2 > name1) {
            sortValue = -1;
        }

        return sortValue;
    })

 */
